/**
 * /tenants/$slug/non-human-identities — thin route shim. Domain logic lives in
 * features/nhi-census/.
 */

import { createFileRoute } from "@tanstack/react-router";
import { censusSearchSchema, type CensusSearch } from "@/features/nhi-census/schemas";
import { fetchCensus } from "@/features/nhi-census/queries";
import { queryKeys } from "@/lib/query-keys";
import { CensusPage } from "@/features/nhi-census/pages/census-page";

export const Route = createFileRoute("/_authed/tenants/$slug/non-human-identities/")({
  validateSearch: (raw: Record<string, unknown>): CensusSearch =>
    censusSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.nhiCensus.list(context.tenant.id, deps.search),
      queryFn: () => fetchCensus(context.tenant.id, deps.search),
    }),
  component: CensusPage,
});
